import { NeuIcon } from '@neutron/react';
import styled from 'styled-components';

export const SummaryHeaderBar = styled.div`
  width: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #b0b0b0;
  padding: 0 1rem;
  position: static;
  min-height: 70px;
`;

export const HelpIcon = styled(NeuIcon)`
  padding-bottom: 2px;
`;

export const HintSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.625rem;
  min-width: 10em;
`;
